var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageTextFilled = function SvgMessageTextFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 4.6C21.2 3.71634 20.4837 3 19.6 3H3.6C2.71634 3 2 3.71634 2 4.6V19.3919C2 19.9789 2.67896 20.3052 3.13729 19.9385L6.56047 17.2H19.6C20.4837 17.2 21.2 16.4837 21.2 15.6V4.6ZM17.6 7.5H5.6V8.7H17.6V7.5ZM5.6 12.7H15.6V11.5H5.6V12.7Z"
  })));
};
export default SvgMessageTextFilled;